import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { SiJava, SiJavascript,SiCplusplus,SiPython } from "react-icons/si";
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import Typical from 'react-typical'
import ParticlesBackground from '../particles/ParticlesBackground'
import Slideshow from '../slider/Slideshow'
//https://www.youtube.com/watch?v=F20SxgG5MlM
//https://www.youtube.com/watch?v=W0bEL93tt4k
//https://www.youtube.com/watch?v=4KxHcbQ8GYQ
const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const nameArray = [' ','W','i', 'n', 's', 'o', 'r', '.']
  const jobArray = ['S','o','f','t','w','a','r','e',' ','d','e','v','e','l','o','p','e','r','.',]
  const titleArray = ['V','i','s','i','t','e','d',' ','P','l','a','c','e','s',':']
  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)
  }, [])

  return (
    <>
      <ParticlesBackground/>
      <div className="container home-page">
        {/* */}
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i,</span>
            <br />
            <span className={`${letterClass} _13`}>I</span>
            <span className={`${letterClass} _14`}>'m </span>
            {/*<img
              src={LogoTitle}
              alt="JavaScript Developer Name, Web Developer Name"
            /> */}
            <AnimatedLetters
              letterClass={letterClass}
              strArray={nameArray}
              idx={15}
            />
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={15}
            />
          </h1>
          <h2>
          <Typical
        steps={['Please check out the side bar.', 500,  'Please check out the links below.', 1000]}
        loop={Infinity}
        wrapper="p"
          />
          This Website is Built using React.js. I am still learning how to make this website mobile friendly. <br/>
          I Love to Travel, please checkout my slide show on the right for my top place I have visited. <br/>
            </h2>
          <Link to="/technology" className="flat-button">
            ABOUT TECHNOLOGY
          </Link>
          <Link to="/about" className="flat-button">
            ABOUT ME
          </Link>
          <Link to="/contact" className="flat-button">
            CONTACT ME
          </Link>
        </div>
        <div className="right-zone">
          <h1>          <AnimatedLetters
              letterClass={letterClass}
              strArray={titleArray}
              idx={15}
            /></h1>
          <h1>
          </h1>
          <Slideshow/>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Home
